export enum ClickableTagKind {
    BLUE = "blue",
    GRAY = "gray",
}
